import { DesignUploadMode } from 'swag-common/interfaces';
export const setupFeeForItem = (item, setupFeeForBoxProduct, setupFeeForLogoProduct) => {
  if (item.prod.designUploadMode === DesignUploadMode.box) {
    return setupFeeForBoxProduct;
  }
  return setupFeeForLogoProduct;
};